export default {
  date_format: "MM/DD/YYYY",
  date_time_format: "MM/DD/YYYY hh:mm A",
  time_format: "hh:mm A",
  dateTimeFormat: "MMM DD, YYYY hh:mm A",
  APP_S3_REGION: process.env.REACT_APP_REGION,
  APP_S3_BUCKET: process.env.REACT_APP_S3_BUCKET,
  API_GATEWAY: process.env.REACT_APP_API_GATEWAY,
  APP_COGNITO_REGION: process.env.REACT_APP_REGION,
  APP_COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  APP_CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  APP_IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
  APP_ACCESS_KEY_ID:process.env.REACT_APP_ACCESS_KEY_ID,
  SECRET_ACCESS_KEY_ID:process.env.REACT_APP_SECRET_ACCESS_KEY_ID,
  fetch_refresh_time: 30000,

  // General lead status
  NEW: "N",
  PENDING: "P",
  ORDER_PROCESSED: "OP",
  PUSH_TO_CARRIER: "PC",
  ASSIGN_TO_CARRIER: "AC",
  IN_PROGRESS: "I",
  DELIVERED: "D",
  CANCELLED: "R",

  STATUS_COLORS: {
    N: "red",
    P: "blue",
    OP: "#F0E68C	",
    PC: "geekblue",
    AC: "yellow",
    I: "orange",
    D: "green",
    R: "red",
    PU: "geekblue",
  },
  // Admin diplay lead status
  DISPLAY_LEAD_STATUS: {
    admin: {
      N: "New",
      P: "Pending",
      OP: "Available",
      PC: "Pending Carrier",
      AC: "Assigned",
      I: "In Progress",
      PS: "In Progress",
      PU: "In Progress",
      D: "Delivered",
      INV: "Invoiced",
      PAID: "Paid",
      R: "Order Cancelled",
      DELETE: "Deleted",
    },
    customer: {
      N: "Order Placed",
      P: "Order Placed",
      OP: "Confirmed",
      PC: "Confirmed",
      AC: "Assigned",
      I: "In Progress",
      D: "Delivered",
      R: "Order Cancelled",
      PS: "In Progress",
      PU: "Mark as Picked up",
      INV: "Invoiced",
      PAID: "Paid",
      DELETE: "Deleted"
    },
    carrier: {
      PC: "New",
      AC: "Assigned to Me",
      I: "In Progress",
      D: "Delivered",
      R: "Order Cancelled",
      PU: "Picked up",
      PS: "In Progress",
    },
    driver: {
      I: "Start",
      PS: "Mark as Picked up",
      PU: "Mark as Delivered",
      D: "Mark as Completed",
    },
  },

  CARRIER_AND_CUSTOMER_STATUS: {
    A: "Approved",
    P: "Pending",
    D: "Rejected",
    F: "Frozen",
  },

  roles: [
    {
      label: "Add Order",
      value: "addOrder",
    },
    {
      label: "Edit Order",
      value: "editOrder",
    },
    {
      label: "Update Order Status",
      value: "updateOrderStatus",
    },
    {
      label: "Edit Customer",
      value: "editCustomer",
    },
    {
      label: "Edit Carrier",
      value: "editCarrier",
    },
    {
      label: "Add Product",
      value: "addProduct",
    },
    {
      label: "Edit Product",
      value: "editProduct",
    },
    {
      label: "Add Load Locations",
      value: "addLoadLocations",
    },
    {
      label: "Edit Load Locations",
      value: "editLoadLocations",
    },
  ],

  entityNames: {
    products: "products",
    registrations: "customerAndCarrierRegistrations",
    users: "users",
    adminUsers: "adminUsers",
    leads: "orders",
    organizations: "organizations",
    cart: "cart",
    notifications: "notifications",
    masterData: "masterData",
    priceQuoteToolData: "priceQuoteToolData",
    customerProducts: "customerProducts",
    newProductCalculation: "newProductCalculation",
    netWeight: "updateCreditAmountByNetWeight",
    getCustomerCarriers:"getCustomerCarriers"
  },

  getCustomerProducts: "getCustomerProducts",
  sendPriceQuote: "sendPriceQuote",
  sendBol:"sendBol",
  getProductDetails: "getProductDetails",
  getDrivers: "getDrivers",
  assignProductsApi: "assignProducts",
  getRegisterDetails: "getRegisterDetails",
  getCartData: "getCartData",
  addOrder: "addOrder",
  carrierLeads: "getLeadsData",
  myLeadsData: "myLeadsData",
  pushToCarrier: "pushToCarrier",
  assignLead: "assignLead",
  approveLoadAssignment: "approveLoadAssignment",
  addItemToCart: "addItemToCart",
  updateCustomerProductPrices: "updateCustomerProductPrices",
  needHelpMessage: "needHelpMessage",
  customerRequestProducts: "customerRequestProducts",
  addCustomerLocation: "addCustomerLocation",
  updateOrderPickupLocation: "updateOrderPickupLocation",
  addProduct: "addProduct",
};
